module.exports = __webpack_public_path__ + "cards.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/components/editor/styled/cards.png
// module id = 2125
// module chunks = 0